import { useState, useEffect } from 'react'
import { apiFetch } from '../lib/api'
import { HelpDot } from './guidance/Guidance'

/* The close moment (value-audit proposal #3, 2026-07-24): a drop that ends
 * with ZERO new officer work is the engine's strongest property
 * (determinism) rendered as… nothing happening. When the queue is empty,
 * say the quiet win out loud: how many documents were processed recently
 * and that every one reconciled against the existing record.
 * Read-only; falls back to the plain all-clear line when the documents
 * read fails or nothing was processed recently. */

interface DocRowLite {
  status: string
  upload_date: string
}

const DAY_MS = 24 * 3600 * 1000

export default function AllClear() {
  const [recent, setRecent] = useState<number>(0)

  useEffect(() => {
    let cancelled = false
    apiFetch<DocRowLite[]>('/api/documents?sort=upload_date&order=desc')
      .then((docs) => {
        if (cancelled) return
        const cutoff = Date.now() - DAY_MS
        setRecent(
          (docs ?? []).filter(
            (d) => d.status === 'processed' && new Date(d.upload_date).getTime() >= cutoff
          ).length
        )
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <span data-testid="all-clear">
      {recent > 0
        ? `${recent} document${recent === 1 ? '' : 's'} processed in the last 24 hours — everything reconciled against the existing record. Nothing needs you.`
        : 'Nothing needs you — the record is current.'}{' '}
      <HelpDot k="surface.all_clear" />
    </span>
  )
}
